import { setConfiguration } from '@configuratorware/configurator-frontendgui/App/configuration';
import Api from '@configuratorware/configurator-frontendgui/Framework/Api';
import configuratorReducer from '../Reducers/Configurator/Reducer';
import ConfiguratorScreen from '../Screens/ConfiguratorScreen';
import uiReducer from '../Reducers/UI/Reducer';
import VisualizationService from '../Services/VisualizationService';
import ItemOverview from '../Screens/ItemOverview';

const prod = process.env.NODE_ENV === 'production';

const envDomains = {
  test: '',
  int: '',
  local: 'http://int.wissner-bosserhoff.local',
  //local: 'http://localhost:10850',
  prod: '',
};

const domain = envDomains[prod ? 'prod' : 'local'];

const query = new URLSearchParams(location.search);

const adminMode = query.get('_adminmode');
export const hidePrices = query.get('_hide_prices') === '1';

const customApplicationConfiguration = {
  network: {
    // timeout: 40000,
    host: domain,
    baseURL: `${domain}/frontendapi/`,
    adminBaseURL: `${domain}/api/`,
    imageURL: `${domain}`,
    resourcesURL: `${domain}`,
  },
  screens: {
    Configurator: ConfiguratorScreen,
    ItemOverview: ItemOverview,
  },
  reducers: {
    configurator: configuratorReducer,
    ui: uiReducer,
  },
  services: {
    VisualizationService,
  },
  hidePrices: hidePrices,
  disableBeforeunloadWarning: true,
};

setConfiguration(customApplicationConfiguration);

if (adminMode) {
  // in admin mode all requests should contain the no-cache header to get the most fresh content
  Api.setCacheControlHeader('no-cache');
}

export default customApplicationConfiguration;
